// I cinque passaggi della catena mostrata in home. È contenuto editoriale:
// se cambia il funzionamento della piattaforma, cambia QUI e in nessun altro punto.

export interface Metrica { etichetta: string; valore: string }
export interface Anello {
  id: string;
  numero: string;
  nome: string;
  sottotitolo: string;
  cifra: string;
  claim: string;
  punti: { testo: string }[];
  garanzia: string;
  metriche: Metrica[];
  azione: string;
  link: string;
}

export const ANELLI: Anello[] = [
  {
    id: 'corpus', numero: '01', nome: 'Il corpus normativo', sottotitolo: 'soltanto fonti scelte dall’ente',
    cifra: '2.543 documenti',
    claim: 'UranIA non cerca in rete: consulta soltanto le fonti che l’ente ha scelto di includere. Un archivio distinto per ciascun fondo, conservato in versioni datate.',
    punti: [
      { testo: 'Regolamenti UE, normativa nazionale, atti regionali, linee guida e prassi: ogni documento entra con il suo rango.' },
      { testo: 'Le norme abrogate restano archiviate ma non sono citabili come base giuridica.' },
      { testo: 'Ogni fonte entra nel corpus solo dopo l’approvazione di una persona, registrata nel fascicolo.' },
    ],
    garanzia: 'Ogni versione dell’archivio è immutabile: una risposta ottenuta oggi resta ricostruibile fra tre anni, davanti a un auditor.',
    metriche: [{ etichetta: 'documenti indicizzati', valore: '2.543' }, { etichetta: 'frammenti indicizzati', valore: '167.416' }, { etichetta: 'archivi per fondo', valore: '3' }],
    azione: 'Vedi il grafo del corpus', link: '/console/grafo',
  },
  {
    id: 'rag', numero: '02', nome: 'Il recupero delle fonti', sottotitolo: 'l’articolo esatto, con la sua vigenza',
    cifra: 'recall 0,89',
    claim: 'Prima che un modello formuli una risposta, il sistema individua i passaggi pertinenti e li ordina secondo la gerarchia delle fonti.',
    punti: [
      { testo: 'Gerarchia applicata: diritto dell’Unione, normativa nazionale, normativa regionale, prassi.' },
      { testo: 'Filtro di vigenza: ciò che è abrogato non arriva al modello come base giuridica attiva.' },
      { testo: 'Se due fonti di pari rango divergono, il contrasto viene dichiarato e non risolto d’ufficio.' },
    ],
    garanzia: 'Nessuna risposta priva di fonte: se la base giuridica non è nell’archivio, il sistema lo dichiara anziché supplire con una formulazione plausibile.',
    metriche: [{ etichetta: 'recall@10', valore: '0,89' }, { etichetta: 'citazioni verificate', valore: '94%' }, { etichetta: 'risposte senza fonte', valore: '3,1%' }],
    azione: 'Interroga il corpus', link: '#chiedi',
  },
  {
    id: 'agenti', numero: '03', nome: 'Gli agenti specializzati', sottotitolo: 'uno per ciascun compito',
    cifra: '9 specializzati',
    claim: 'Non un assistente generico, ma agenti dal compito circoscritto: ciascuno con le proprie istruzioni versionate, il proprio archivio di riferimento e una soglia di qualità da superare.',
    punti: [
      { testo: 'Redazione, base giuridica, aiuti di Stato, istruttoria, conformità, estrazione dati, linguaggio piano, trasparenza, anonimizzazione.' },
      { testo: 'Ogni agente dichiara quale modello lo esegue: i dati sensibili restano su modelli on-premise.' },
      { testo: 'Sotto 0,90 di valutazione un agente resta in collaudo e non entra in produzione.' },
    ],
    garanzia: 'Un agente propone e cita: non sottoscrive. Il testo che entra in un atto resta attribuito a chi lo ha confermato.',
    metriche: [{ etichetta: 'agenti in produzione', valore: '8 su 9' }, { etichetta: 'valutazione media', valore: '0,94' }, { etichetta: 'modelli on-premise', valore: '73% del lavoro' }],
    azione: 'Vedi la libreria skill', link: '/console/skill',
  },
  {
    id: 'orchestratore', numero: '04', nome: 'L’orchestratore', sottotitolo: 'conosce l’ordine di lavorazione',
    cifra: '10 tipologie di atto',
    claim: 'Ogni ente disciplina i propri atti con regole proprie. L’orchestratore conosce la sequenza prevista: quale agente per primo, con quale format, con quali controlli obbligatori.',
    punti: [
      { testo: 'Per un decreto di ammissione: base giuridica, criteri di istruttoria, aiuti di Stato, dispositivo, conformità, trasparenza.' },
      { testo: 'Per un avviso l’ordine cambia; per la base giuridica dell’aiuto si parte dal controllo dell’aiuto.' },
      { testo: 'La sequenza è visibile e interrompibile: si può eseguire una singola funzione quando serve soltanto quella.' },
    ],
    garanzia: 'L’orchestrazione esegue e riferisce, non riscrive l’atto: nessun passaggio entra nel testo senza una conferma esplicita.',
    metriche: [{ etichetta: 'sequenze codificate', valore: '10' }, { etichetta: 'format dell’ente', valore: '14' }, { etichetta: 'tempo medio per atto', valore: '−38%' }],
    azione: 'Vai a «Da dove partiamo»', link: '/immersivo',
  },
  {
    id: 'atto', numero: '05', nome: 'L’atto tracciato', sottotitolo: 'ogni decisione motivata',
    cifra: 'fascicolo su 100% degli atti',
    claim: 'Il risultato non è un testo, ma un atto accompagnato dal proprio fascicolo: fonti citate, modello che ha risposto, versione dell’archivio, revisore che ha validato, motivazione.',
    punti: [
      { testo: 'I passaggi proposti dall’IA restano marcati nel testo, con la fonte a fianco.' },
      { testo: 'Nessuna bozza è protocollabile senza validazione umana registrata.' },
      { testo: 'Il fascicolo si esporta per l’auditor in un unico documento.' },
    ],
    garanzia: 'L’obbligo di trasparenza previsto dall’AI Act è assolto per costruzione e non per dichiarazione: la tracciabilità fa parte del risultato, non è un allegato.',
    metriche: [{ etichetta: 'atti con fascicolo', valore: '100%' }, { etichetta: 'citazioni tracciate', valore: '412' }, { etichetta: 'atti in lavorazione', valore: '23' }],
    azione: 'Vedi un fascicolo', link: '#fascicolo',
  },
];
